import { render, staticRenderFns } from "./classDetail.vue?vue&type=template&id=3752f411&scoped=true"
import script from "./classDetail.vue?vue&type=script&lang=js"
export * from "./classDetail.vue?vue&type=script&lang=js"
import style0 from "./classDetail.vue?vue&type=style&index=0&id=3752f411&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752f411",
  null
  
)

export default component.exports